import React, { useEffect, useState } from 'react';
import { getListeAllPDV } from '../../../../services/Rapports/RapportsApi';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import SqaureLoader from '../../../../components/Loader/SqaureLoader';

const ModalAllPlanifiee = ({ t, user_code, onClose }) => {
    const [listePdvUser, setListePdvUser] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        if(user_code){
        getListeAllPDV(user_code)
            .then((result) => {
                if (result?.status === 200) {
                    setListePdvUser(result?.data?.data);
                }
            }).catch((err) => {
                console.log(err);
            }).finally(() => {
                setLoading(false);
            });
        }
    }, [user_code]);

    return (
        <div className="modal fade show" id="pdvVisité1" data-backdrop="static" tabIndex={-1} role="dialog" aria-labelledby="pdvVisité1" aria-hidden="true" style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
            <div className="modal-dialog" role="document">
                <div className="modal-content" style={{ width: "max-content" }}>
                    <div className="modal-header">
                        <h5 className="modal-title" id="pdvVisité"> <i className='fe fe-tag text-azure mr-1' /> {t('PDV Portfeuille')}   </h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => onClose()}>
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        {loading ? <SqaureLoader /> : (
                            <div className="table-responsive product-datatable" style={{ overflow: 'auto', height: '500px' }}>
                                <table className="table table-bordered">
                                    <thead className="text-center bg-bleu  fs-10" style={{ position: "sticky", top: 0, zIndex: 1, backgroundColor: "#1A4BE3" }}>
                                        <tr>
                                            <td className='fs-10'>#</td>
                                            <td className="wd-15p fs-10">{t('Code')}</td>
                                            <td className="wd-15p fs-10">{t('Magasin')}</td>
                                            
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {listePdvUser?.map((items, keys) => (
                                            <tr key={keys} className="text-center fs-10">
                                                <td className='fs-10'>{keys + 1}</td>
                                                <td>{items.code}</td>
                                                <td>{items.nompdv}</td>
                                                
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>

                    <div className="modal-footer ">
                                        <ReactHTMLTableToExcel
                                                id="test-table-xls-button"
                                                className="btn btn-azure fs-10"
                                                table="table-magasins"
                                                filename="liste_Magasins"
                                                sheet="tablexls"
                                                buttonText={<span className=" text-center"> <i className="icon icon-share-alt mr-1" /> {t('rapportrupture.exporter')}</span>}
                                            />
                                            <button type="button" className="btn btn-secondary fs-10" data-dismiss="modal" > <i className="ti-close mr-1" />{t('Routings.annueler')}</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModalAllPlanifiee;
